import { Button, ButtonContainer, Card, ErrorMessage, Heading, Layout, Paragraph } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { DealerCard } from "./DealerCard";
import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";
import { useEffect, useState } from "react";
import { DealerData } from "../../interfaces/IDealerData";
import { BrandType } from "@bus/models";

export const DealerSearchResult = () => {
    const { dealersList, firstSearch, isLoading } = useMatchMakerWizard();
    const { t } = useTranslation(["dealerselection"]);
    const [numDealerAppear, setNumDealerAppear] = useState<number>(4);
    const [dealerShowList, setDealerShowList] = useState<DealerData[]>([]);
    const brand = process.env.REACT_APP_WEBSITE_BRAND;

    useEffect(() => {
        setDealerShowList(
            dealersList.slice(0, dealersList.length >= numDealerAppear ? numDealerAppear : dealersList.length + 1)
        );
    }, [dealersList, numDealerAppear]);

    const handleShowMoreDealers = () => {
        setNumDealerAppear(numDealerAppear + 4);
    };

    return (
        <Layout.Item>
            {dealerShowList && dealerShowList.length > 0 && (
                <>
                    <Heading className="u-font-size-fs2" level={1}>{t("dealerselection:dealer-search-section.results")}</Heading>
                    <Layout equalHeight id="DealersSearchResult">
                        {dealerShowList.map((dealer, index) => (
                            <Layout.Item default="1/4" m="1/2" s="1/1" key={`Dealer_${dealer.id}_${index}`}>
                                <DealerCard dealer={dealer} />
                            </Layout.Item>
                        ))}
                    </Layout>
                    <Layout>
                        <Layout.Item>
                            {numDealerAppear < dealersList.length ? (
                                <ButtonContainer nav className="u-mt">
                                    <Button secondary icon="arrow-down" onClick={handleShowMoreDealers}>
                                        {brand === BrandType.AUDI ? t("dealerselection:dealer-search-section.more-results-audi") : t("dealerselection:dealer-search-section.more-results")}
                                    </Button>
                                </ButtonContainer>
                            ):
                                <Layout>
                                    <Layout.Item>
                                        <ErrorMessage>{t('errormessages:6')}</ErrorMessage>                                    
                                    </Layout.Item>
                                </Layout>
                            }
                        </Layout.Item>
                    </Layout>
                </>
            )}
            {!firstSearch && (!dealerShowList || dealerShowList.length === 0) && !isLoading && (
                <>
                    <Heading className="u-font-size-fs2" level={1}>{t("dealerselection:dealer-search-section.results")}</Heading>
                    <Card title="">
                        <Paragraph>{t("dealerselection:dealer-search-section.no-data")}</Paragraph>
                    </Card>
                </>
            )}
        </Layout.Item>
    );
};
